// External Imports
import React from 'react';
import PropTypes from 'prop-types';

import Table from 'react-bootstrap/Table';

import { useTimezoneContext } from '../utils/TimezoneContext';
import { formatInTimezone } from '../utils/tzFormat';

const DATE_TIME_OPTIONS = {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
};

//Main View
export default function ShowVolumePeriods({ periods }) {
  const { timezone } = useTimezoneContext();

  const formatTime = (iso) =>
    iso ? formatInTimezone(new Date(iso), timezone, DATE_TIME_OPTIONS) : '—';

  return (
    <Table striped>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Start</th>
          <th>End</th>
          <th>Consumed</th>
          <th>Available</th>
        </tr>
      </thead>
      <tbody>
        {periods.map((period) => (
          <tr key={period.start_time}>
            <td>{period.reason}</td>
            <td>{formatTime(period.start_time)}</td>
            <td>{formatTime(period.end_time)}</td>
            <td>{period.utilisation_gb} GB</td>
            <td>{period.allowance_gb} GB</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

ShowVolumePeriods.propTypes = {
  periods: PropTypes.array,
};
